import React, { useSyncExternalStore } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { moniteurReseau } from '../utils/moniteurReseau';
import { CHARTE_COLORS } from '../variables/constants';

/**
 * Bandeau d'avertissement quand une requete traine. Volontairement mince : il
 * ne decide de rien, il donne a voir l'etat tenu par `moniteurReseau`, ou vit
 * toute la logique - et ou elle est testee.
 *
 * Il se cale sous la NavBar (fixe, 56 px de haut) et epouse son retrait a
 * gauche. Sur l'ecran de connexion, ou il n'y a pas de barre laterale, la
 * variable retombe a 0 et le bandeau prend toute la largeur.
 */
const S = {
  bandeau: {
    position: 'fixed', top: 'calc(56px + var(--cb-banniere-h, 0px))', left: 'var(--cb-sidebar-w, 0px)', right: 0,
    // Sous la NavBar (999), au-dessus du contenu.
    zIndex: 998,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    padding: '6px 16px',
    background: CHARTE_COLORS.amberBg, color: CHARTE_COLORS.amber,
    fontSize: 13, lineHeight: 1.4,
    borderBottom: `1px solid ${CHARTE_COLORS.amber}33`,
    transition: 'left var(--tr-base)',
  },
};

export default function BandeauConnexionLente() {
  const { t } = useTranslation('commun');
  const lent = useSyncExternalStore(moniteurReseau.subscribe, moniteurReseau.estLent);

  if (!lent) return null;

  return (
    <div style={S.bandeau} role="status" aria-live="polite">
      <LoadingOutlined aria-hidden="true" />
      <span>{t('bandeauConnexionLente.message')}</span>
    </div>
  );
}
